import { ReactNode, useCallback, useState } from 'react'

import PlainModal, {
  PlainModalHeader,
  HandleModalDisplayed,
  PlainModalContent,
  PlainModalFooter,
} from 'app/common/ui-next/plain-modal'
import ControlsBar from 'app/common/ui-next/controls-bar'
import PlainButton from 'app/common/ui-next/plain-button'
import { useSaleTypesData } from 'app/dataProviders/SaleTypesData'
import usePopup from 'app/common/hooks/usePopup'

import { EditProductionTypeForm, FormControl } from './EditProductionTypeForm'


type Props = {
  children: (toggle: HandleModalDisplayed) => ReactNode
}

export const AddProductionTypeModal = ({ children }: Props) => {
  const [submitting, setSubmitting] = useState(false)
  const [modify, setModify] = useState(false)

  const { createSaleType } = useSaleTypesData()

  const popup = usePopup()

  const handleSubmit = useCallback(async (form: HTMLFormElement) => {
    setSubmitting(true)
    const formData = new FormData(form)
    const title = formData.get(FormControl.Name) as string
    const res = await createSaleType({ title })
    setSubmitting(false)
    if (res) popup('Тип продукции успешно создан')
    return !!res
  }, [createSaleType, popup])

  return (
    <PlainModal
      formId="addProductionType"
      controlBy={children}
      onSubmit={handleSubmit}
    >
      <PlainModalHeader>{'Добавление типа продукции'}</PlainModalHeader>
      <PlainModalContent>
        <EditProductionTypeForm onModify={setModify} />
      </PlainModalContent>
      <PlainModalFooter>
        {handleModalDisplayed => (
          <ControlsBar right>
            <PlainButton
              type="submit"
              disabled={submitting || !modify}
            >
              {submitting ? 'Добавление...' : 'Добавить'}
            </PlainButton>

            <PlainButton
              outline
              onClick={handleModalDisplayed}
            >
              {'Отмена'}
            </PlainButton>
          </ControlsBar>
        )}
      </PlainModalFooter>
    </PlainModal>
  )
}
